import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import redirectURL from "../redirectURL"; // Assuming redirectURL is an axios instance

class OptipredUser extends Component {
  constructor(props) {
    super(props);
    this.state = { successLogin: 0 };
  }

  async componentDidMount() {
    console.log(this.props, "efop");
    // const token = this.props.match.params.token;
    let url_type = window.location.href;

    console.log(url_type, "url_type");
    let path_type = url_type.split("/");
    // const token = path_type[path_type.length - 1];
    var main_token = window.location.pathname.split("/");
    const token = main_token[main_token.length - 1];
    var ppwwdd = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
    // var usrtoken = ppwwdd(token)
    var params = {
      token: token,
    };
    try {
        const url = window.location.href;
        const emailMatch = url.match(/optipreduser\/([^&]+)/);
        const passwordMatch = url.match(/&([^&]+)/);

        if (!emailMatch || !passwordMatch) {
        throw new Error("Invalid URL format");
        }

        const email = atob(emailMatch[1]);
        const password = atob(passwordMatch[1]);

        var params = {
          e: email,
          d: password,
        };
        console.log(params, "params")
        redirectURL.post("/verify", params).then((response) => {
          if (response.data.status == "success") {
            localStorage.setItem("email", response.data.user[0].email);
            sessionStorage.setItem("twtemail",response.data.user[0].email);
            localStorage.setItem("firstname", response.data.user[0].firstname);
            localStorage.setItem("lastname", response.data.user[0].lastname);
            localStorage.setItem("username", response.data.user[0].username);
            Cookies.set("username", response.data.user[0].username, {
              expires: 7,
            });
            Cookies.set("token", response.data.user[0].username, {
              expires: 7,
            });
            // Cookies.set("token",response.data.token,{ expires: (40/(24*60*60)) });
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("user_type", response.data.user[0].user_type);
            localStorage.setItem("client", response.data.user[0].client);
            localStorage.setItem("userid", response.data.user[0]._id);
            if (response.data.user[0].location_access != undefined) {
              localStorage.setItem(
                "location_access",
                JSON.stringify(response.data.user[0].location_access)
              );
            }
            localStorage.setItem("role", response.data.user[0].role);
            localStorage.setItem("user_code", response.data.user[0].user_code);
            this.setState({
              isNav: 1,
            });
          } else {
            this.setState({
              loginMessage: response.data.message,
              captchaMsg: "",
            });
          }
        });

      // if (response.status === 200) {
      //     if (response.data.auth) {
      //         if (response.data.otpAuthentication === 1) {
      //             this.setState({
      //                 otpAuthentication: response.data.otpAuthentication,
      //                 otpMessage: "OTP has been sent to your Email",
      //                 userData: response.data,
      //                 successLogin: 0,
      //             });
      //         } else {
      //             this.setState({
      //                 "successLogin" : 1,
      //             })
      //             await redirectURL.post("/manage/saveuserlogged", {
      //                 token: response.data.token,
      //                 userId: response.data.userid
      //             });

      //             localStorage.setItem('_t', window.btoa(response.data.token));
      //             localStorage.setItem('userid', response.data.userid);
      //             localStorage.setItem('dept_code', JSON.stringify(response.data.user.dept_code));
      //             localStorage.setItem('is_admin', response.data.user.is_admin);
      //             localStorage.setItem('is_dept_admin', response.data.user.is_dept_admin);
      //             localStorage.setItem('is_global', response.data.user.is_global);
      //             localStorage.setItem('firstname', response.data.user.firstname);
      //             localStorage.setItem('username', response.data.user.username);
      //             localStorage.setItem('lastname', response.data.user.lastname);
      //             // localStorage.setItem('pc', response.data.user.plant_code || "HZ");
      //             localStorage.setItem('email', response.data.user.email.replace("[at]", "@").replace("[dot]", "."));
      //             localStorage.setItem('user_type', response.data.user.user_type);
      //             // localStorage.setItem('plant_code', response.data.user.plant_code || "");
      //             localStorage.setItem('roles', response.data.user.roles);
      //             localStorage.setItem("successLogin",this.state.successLogin)
      // 			localStorage.setItem('usermenus', JSON.stringify(response.data.menus));
      // 			//console.log("response.data.usermenucodes ", response.data.usermenucodes);
      // 			localStorage.setItem('usermenucodes', JSON.stringify(response.data.usermenucodes));
      //             // localStorage.setItem('actual_roles', response.data.user.roles);
      //             sessionStorage.setItem('ref', 1);

      //             this.setState({
      //                 username: '',
      //                 email: '',
      //                 password: '',
      //                 loginMessage: response.data.msg
      //             });
      //         }
      //     } else {
      //         this.setState({
      //             username: '',
      //             email: '',
      //             password: '',
      //             loginMessage: response.data.msg
      //         });
      //     }
      // } else {
      //     this.setState({
      //         username: '',
      //         email: '',
      //         password: '',
      //         loginMessage: response.data.msg
      //     });
      // }
    } catch (error) {
      console.error("Error authenticating user:", error);
    }
  }

  getUserDashboardUrl(pathToMatch = null) {
    var uroles = localStorage.getItem("roles");
    var arr = [];

    // redirectURL.post("/menus/roleinfo",{role:uroles})
    // .then((res) => {
    // 	//console.log("repson ", response.data)
    // 	var rec = res.data
    // 	if(rec.length > 0)
    // 	{
    // 		rec.map((item) => {
    // 			if(item.dashboard_url != '' && item.dashboard_url != undefined)
    // 			{
    // 				arr.push(item.dashboard_url)
    // 			}
    // 		})

    // 	}
    // 	else
    // 	{
    // 		arr.push("/dashboard/default")
    // 	}
    // 	if(arr.length > 0)
    // 	{

    // 		this.setState({
    // 			landingpage:arr[0]
    // 		});
    // 	}
    // 	else
    // 	{
    // 		this.setState({
    // 			landingpage:"/dashboard/default"
    // 		});
    // 	}
    // 	//return dashboardUrl;
    // })

    let dashboardUrl = "dashboard/default";
    let currentDepartmentCode = null;
    let departmentCode = JSON.parse(localStorage.getItem("dept_code"));

    //console.log("IN render, departmentCode ", departmentCode);
    if (Array.isArray(departmentCode)) {
      currentDepartmentCode = departmentCode[0];
    } else {
      currentDepartmentCode = departmentCode;
    }
    console.log("dashboardUrl Login", dashboardUrl);
    return dashboardUrl;
  }

  cipher = (salt) => {
    console.log(salt, "sdfji");
    const textToChars = (text) => {
      text.split("").map((c) => c.charCodeAt(0));
      console.log(text, "sedhui");
    };
    const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return (text) =>
      text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
  };
  render() {
    // if(localStorage.getItem('_t') != '' && localStorage.getItem('_t') != null)
    // {
    // 	var successLogin = this.state.successLogin;
    //     console.log(successLogin,"successLogin")
    // 	if(successLogin == 1)
    // 	{
    // 		let dashboardUrl = this.getUserDashboardUrl();
    // 		console.log(dashboardUrl,"dashboardUrl1143");
    // 		//let dashboardUrl = this.state.landingpage;
    // 		// return <Redirect to="dashboard/snddefault" push={true} />

    // 		return <Redirect to={dashboardUrl} push={true} />
    // 	}
    // }
    if (this.state.isNav === 1) {
      if (localStorage.getItem("user_type") === "SERVICE") {
        // return <Navigate  to={"/trips"} push={true} />
        return (window.location.href = "/trips");
      } else {
        // return (window.location.href = "/home-page");
        return (window.location.href = "/");
      }
    }
    // console.log(Cookies.get('token'),'hello')
    if (
      Cookies.get("token") !== undefined &&
      Cookies.get("token") !== "" &&
      Cookies.get("token") !== null
    ) {
      // return (window.location.href = "/home-page");
      return (window.location.href = "/");
    }


    return (
      <div>
        {/* Loader starts */}
        <div className="loader-wrapper">
          <div className="loader bg-white">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <h4>
              Authenticating... <span>&#x263A;</span>
            </h4>
          </div>
        </div>
        {/* Loader ends */}
      </div>
    );
  }
}

export default OptipredUser;
